import React from 'react';
import '../stylesheets/account.scss';


 
class NavbarElementAccount extends React.Component {
  render() {
    let datas = this.props.data;
    let navbarElementClicked = this.props.navbarElementClicked; 
    let dataValue = datas.dataValue;

    return (
      <li
        id={datas.id}
        className='navbar-right-element-account'
        data-value={dataValue}
        onClick={this.props.navbarAnimationHandle}
      >
        <div className={navbarElementClicked === dataValue ? 'navbar-title' : 'navbar-title-no-clicked'}>
          <h2>{datas.item}</h2>
        </div>
      </li>
    );
  }
};

export default NavbarElementAccount;